<template>
    <div>
        <router-view name="header"></router-view>

        <main>
            <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>

        <router-view name="footer"></router-view>

        <gh-back-to-top />

        <gh-gdpr @change="handleGdpr"/>
    </div>
</template>

<script>
    import jwt from '../utils/jwt';

    export default {
        components: {
            ghBackToTop: () => import(/* webpackChunkName: "layout" */ '@/components/ui/backToTop'),
            ghGdpr: () => import(/* webpackChunkName: "layout" */ '@/components/gdpr')
        },

        mounted() {
            this.$router.onReady(() => {
                if (this.$route.query.accessToken) {
                    jwt.setToken(this.$route.query.accessToken)
                    window.location.replace('/dashboard')
                }
            });
        },

        methods: {
            handleGdpr (accepted) {
                if (accepted) {
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-PG63X8P');
                }
            }
        }
    }
</script>
